// Module
var code = "<div> <ul> <li> <label> <span><strong>Applicant Identity</strong></span> <a href=\"#\" class=\"alignr\" @click.stop.prevent=\"deletePath()\" aria-label=\"Remove identity\"> <icon name=\"delete\" class=\"blue\"></icon> </a> </label> </li> </ul> </div> ";
// Exports
export default code;